module.exports = __webpack_public_path__ + "img/logo.b5f73d34.png";